import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {};
type Response = {
  data: Car[];
};

export const useNeedsSetupCars = createQuery<Response, Variables, AxiosError>({
  queryKey: ['internal/partners/cars/needs-setup'],
  fetcher: () => {
    return client
      .get(`v2/internal/partners/cars/needs-setup`)
      .then((response) => {
        return response.data.data;
      });
  },
});
